import React from 'react';

function ExitIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="16"
      fill="none"
      viewBox="0 0 14 16"
    >
      <g clipPath="url(#clip0_1001_6131)">
        <path
          fill="#EF4136"
          d="M14 3.556v8.888A3.561 3.561 0 0110.43 16H6.39c-1.504 0-2.632-.655-3.195-1.778-.282-.468-.094-1.029.375-1.216.47-.28 1.034-.094 1.222.374.282.468.752.749 1.503.749h4.04a1.68 1.68 0 001.692-1.685V3.556a1.68 1.68 0 00-1.691-1.685H6.389c-.657 0-1.127.187-1.41.655-.281.468-.845.562-1.315.281-.47-.28-.563-.842-.281-1.31C4.04.561 5.073 0 6.389 0h4.04C12.404 0 14 1.59 14 3.556zM3.664 11.509c.282 0 .47-.094.658-.28a.902.902 0 000-1.31L3.195 8.794h5.261c.564 0 .94-.374.94-.935 0-.562-.376-.936-.94-.936H3.195l1.033-1.03a.902.902 0 000-1.31.91.91 0 00-1.315 0L.282 7.205C.094 7.393 0 7.58 0 7.86c0 .28.094.467.282.655l2.725 2.713c.188.187.376.28.657.28z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1001_6131">
          <path fill="#fff" d="M0 0H14V16H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default ExitIcon;
